import findClosestElementAncestor from '../utils/findClosestElementAncestor';
/**
 * @internal
 * Get Root list node from the given node within the given region
 * @param region Region to scope the search into
 * @param selector The selector to search
 * @param node The start node
 */
export default function getRootListNode(region, selector, node) {
    var list = region &&
        findClosestElementAncestor(node, region.rootNode, selector);
    if (list) {
        var ancestor = void 0;
        while ((ancestor = findClosestElementAncestor(list.parentNode, region.rootNode, selector))) {
            list = ancestor;
        }
    }
    return list;
}
//# sourceMappingURL=getRootListNode.js.map